<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="history"
          redirect_name="gamification-detail"
          :redirect_param="redirect_param"
        />
      </v-col>
    </v-row>

    <v-col cols="12" sm="12" md="12" class="my-4">
      <v-row>
        <v-col
          v-for="(item, index) in dataItems"
          :key="index"
          cols="12"
          class="pt-0"
        >
          <v-card
            class="rounded-lg pa-3 card-container d-flex"
            outlined
            elevation="1"
            width="100%"
            height="100px"
            style="border: none"
            @click="handleClickCard(item)"
          >
            <v-img
              :lazy-src="require('@/assets/images/image.png')"
              :cover="true"
              :aspect-ratio="1"
              style="max-width: 100px; min-width: 100px; border-radius: 8px"
              :src="item.image_url"
            >
            </v-img>

            <div
              class="pl-2 d-flex flex-column justify-between"
              style="width: calc(100% - 100px)"
            >
              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.hideText ? "" : item.name }}
              </p>

              <div class="d-flex w-100 align-end">
                <div style="font-size: 0.8rem; color: #757575">
                  {{ item.created_at | formatDate }}
                </div>

                <v-chip
                  v-if="checkCancel(item)"
                  class="ml-auto"
                  color="gray"
                  dark
                  small
                >
                  {{ $t("cancel") }}
                </v-chip>
                <v-chip
                  v-else-if="checkCanRedeem(item)"
                  class="ml-auto"
                  :color="checkValidRedeem(item) ? 'orange' : 'gray'"
                  dark
                  small
                  :disabled="!checkValidRedeem(item)"
                  @click="handleClickRedeem($event, item)"
                >
                  {{
                    checkValidRedeem(item)
                      ? $t("receiveReward")
                      : $t("notAvailable")
                  }}
                </v-chip>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <div v-if="!dataItems.length">
      <v-img
        class="white--text mx-auto mt-10 empty"
        :src="require('@/assets/images/out-of-stock.png')"
        max-width="200px"
      >
      </v-img>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <!-- Fern: Confirm Redeem Final dialog -->
    <DialogConfirmRedeemFinal
      :dialogConfirmRedeemFinalVisible="dialogConfirmRedeem"
      :site="site"
      :item="rewardItem"
      :quantity="1"
      :btnRedeemText="$t('confirmDefault')"
      :showPointUse="false"
      :fromGamification="true"
      @close="closeConfirmRedeem()"
      @afterRedeemSucess="handleRedeemSuccess"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "@/components/headerTextBg.vue";
import DialogConfirmRedeemFinal from "@/components/reward/dialogConfirmRedeemFinal.vue";
import moment from "moment";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    DialogConfirmRedeemFinal,
  },
  data() {
    return {
      dataItems: [],
      redirect_param: { id: null },
      rewardItem: {},
      dialogConfirmRedeem: false,
    };
  },

  async created() {
    this.redirect_param = {
      id: this.$route.params.id,
    };
    this.isAppLoading(true);
    await this.initial();
    this.isAppLoading(false);
  },
  methods: {
    checkCanRedeem(item) {
      let check = true;
      if (
        this.site.account_type == "group_account" &&
        this.customer.parent_employee_id
      ) {
        check = false;
      }
      if (item.status != "waiting") {
        check = false;
      }
      return check;
    },
    checkValidRedeem(item) {
      let check = true;
      if (item.reward_status != "active") {
        check = false;
      } else {
        const reward = item.reward;
        if (reward) {
          const now = moment();
          const start_date = moment(reward.start_date);
          const expires_at = moment(reward.expires_at);
          if (!(now.isAfter(start_date) && now.isBefore(expires_at))) {
            check = false;
          }
        }
      }
      return check;
    },
    checkCancel(item) {
      let check = false;
      if (item.status == "cancel") {
        check = true;
      }
      return check;
    },
    async initial() {
      try {
        const response = await Axios.post(
          `gamification/getGamificationTransaction/${this.$route.params.id}`
        );
        const dataResponse = response?.data || null;
        if (dataResponse.status == "success") {
          let list = [...dataResponse.data];
          list = list.map((x) => {
            x.item_type = x.item_json?.item_type || "";
            x.image_url = x.item_json?.image || "";
            x.name = x.item_json?.name || "";
            x.reward_status = x.reward?.status || "active";
            return x;
          });
          this.dataItems = [...list];
        }
      } catch (err) {
        console.log("initial", err);
      }
    },

    async handleClickRedeem(event, item) {
      event.stopPropagation();
      if (!item.reward) return;
      this.rewardItem = {
        gamification_transactions_id: item.id,
        ...item.reward,
      };
      this.dialogConfirmRedeem = true;
    },
    closeConfirmRedeem() {
      this.dialogConfirmRedeem = false;
    },
    async confirmRedeem(item) {
      try {
        const response = await Axios.post(
          `gamification/redeemRewardGamification/${item.id}`,
          {
            address_id: null,
          }
        );
        const dataResponse = response?.data || null;
        if (dataResponse.status == "success") {
          ///
        }
      } catch (err) {
        console.log("confirmRedeem", err);
      }
    },
    async handleRedeemSuccess() {
      this.closeConfirmRedeem();
      this.isAppLoading(true);
      await this.initial();
      this.isAppLoading(false);
    },

    handleClickCard(param) {
      const text =
        !param.hideText && param.name
          ? `<div style="font-weight: 400; margin-bottom: 8px;"><div style="font-weight: 600;">${param.name}</div></div>`
          : ``;
      const image = param.image_url
        ? `<img style="width: 100%; object-fit: contain;" src="${param.image_url}" />`
        : ``;
      let html = `
          ${text}
          ${image}
        `;
      this.$swal.fire({
        icon: "",
        html: html,
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$t("close"),
        cancelButtonColor: "#2196F3",
        allowOutsideClick: false,
      });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMM YY, HH:mm");
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  /* background-color: #00000099; */
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
  width: 75%;
  text-align: center;
}
</style>
